import CTAButton from '@/components/shared/CTAButton'
import TrustpilotBadge from '@/components/TrustpilotBadge'

const EgenticHero = () => {
  return (
    <>
      <style>{`
        .egentic-hero-bg {
          background-position: 35% center;
        }
        @media (min-width: 768px) {
          .egentic-hero-bg {
            background-position: center top;
          }
        }
      `}</style>
      <div
        className="egentic-hero-bg relative flex min-h-[70vh] items-center bg-cover bg-no-repeat md:min-h-[91vh]"
        style={{
          backgroundImage: 'url("/Image/egentic-image-5.webp")',
        }}
      >
        <div className="absolute inset-0 bg-black/53"></div>
        <div className="relative z-10 container mx-auto px-4 py-8">
          <div className="px-4 text-center lg:px-20">
            <h1 className="mb-4 text-center text-4xl font-black tracking-tight text-white uppercase sm:mb-6 sm:text-6xl">
              UNLOCK YOUR{' '}
              <span style={{ color: 'rgb(255, 145, 77)' }}>
                CAR FINANCE REFUND
              </span>{' '}
              TODAY
            </h1>
            <p className="font-raleway-numbers mx-auto mb-4 max-w-xl text-lg leading-relaxed font-bold text-white/90 sm:text-xl md:mb-6 md:max-w-3xl lg:text-2xl">
              You could be owed{' '}
              <strong>
                around{' '}
                <span style={{ color: 'rgb(255, 145, 77)' }}>
                  £829 per claim
                  <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>
                    4
                  </sup>
                </span>
              </strong>
              , an average of{' '}
              <strong style={{ color: 'rgb(255, 145, 77)' }}>
                £2,086 per household
                <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>
                  1
                </sup>
              </strong>
              . Millions of UK drivers were overcharged on car finance between
              2007–2024.
            </p>
            <div className="mt-6 flex justify-center">
              <CTAButton text="START YOUR CLAIM NOW" />
            </div>
            <div className="mt-6 flex justify-center md:mt-12">
              <TrustpilotBadge rating="4star" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EgenticHero
